module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority-new/sorority-logos/s-logo-17-043222e7e57fbbdf57928190b1bc336c.svg";